import { Controller } from '@hotwired/stimulus'
import Popover from 'bootstrap/js/dist/popover'

export default class extends Controller {
  static targets = [
    'mod',
    'feature',
    'sumPoints',
    'sumCarClass',
    'summary',
    'regPoints',
    'regMods',
    'regCarClass'
  ]

  calculate() {
    let totalPoints = 0
    const features = { stock: true }
    const finalMods = []

    this.featureTargets.forEach((element) => {
      if (element.checked) features[element.dataset.calculatorKey] = true
    })

    const fa24Swap = document.getElementById('mod-fa24-swap')
    const fa24SwapWithEcu = document.getElementById('mod-fa24-swap-with-ecu')
    if (features.gen2) {
      this.disableMods([fa24Swap, fa24SwapWithEcu])
    } else {
      this.enableMods([fa24Swap, fa24SwapWithEcu])
    }

    const naTuneMods = [
      document.getElementById('mod-oem-tune'),
      document.getElementById('mod-na-tune-low-octane'),
      document.getElementById('mod-na-tune-high-octane')
    ]
    const fiTuneMods = [
      document.getElementById('mod-fi-tune-low-octane'),
      document.getElementById('mod-fi-tune-high-octane')
    ]
    if (features.fi) {
      this.enableMods(fiTuneMods)
      this.disableMods(naTuneMods, fiTuneMods[0])
    } else {
      this.enableMods(naTuneMods)
      this.disableMods(fiTuneMods, naTuneMods[0])
    }

    this.modTargets.forEach((element) => {
      if (element.checked) {
        if (element.dataset.permittedInStock === 'false') features.stock = false

        totalPoints += Number(element.dataset.points)

        const modName = document.getElementById(`name-${element.id}`).firstChild.data
        finalMods.push({
          name: modName,
          points: element.dataset.points,
          id: element.id
        })
      }
    })

    let carClass = this.determineClass(totalPoints, features)

    if (this.hasSummary) this.showResults(totalPoints, carClass, finalMods)
    if (this.hasForm) this.fillForm(totalPoints, carClass, finalMods)
  }

  showResults(points, carClass, mods) {
    this.sumPointsTarget.innerHTML = points.toFixed(1)
    this.sumCarClassTarget.innerHTML = carClass
    this.summaryPopover._config.content = mods.map(({ name, points }) => `${points} - ${name}`).join('\n')
    this.summaryPopover.hide()
  }

  fillForm(points, carClass, mods) {
    this.regPointsTarget.value = points
    this.regModsTarget.value = JSON.stringify(mods)

    let classesToDisable = []
    if (carClass === 'Street') {
      classesToDisable = ['Stock']
    } else if (carClass === 'Touring') {
      classesToDisable = ['Stock', 'Street']
    } else if (carClass === 'Unlimited') {
      classesToDisable = ['Stock', 'Street', 'Touring']
    }

    for (let option of this.regCarClassTarget.options) {
      if (classesToDisable.includes(option.label)) {
        option.disabled = true
        option.selected = false
      } else {
        option.disabled = false
      }
    }
  }

  enableMods(mods) {
    mods.forEach((element) => {
      element.disabled = false
    })
  }

  disableMods(mods, resetTo = null) {
    mods.forEach((element) => {
      if (resetTo != null && element.checked) resetTo.checked = true
      element.checked = false
      element.disabled = true
    })
  }

  determineClass(points, features) {
    if (features['other-swap']) {
      return 'Unlimited'
    }
    if (features.stock && (features.spec_tire || features.oem_tire)) {
      return 'Stock'
    }
    if (points <= 3.0001) {
      return features.spec_tire || features.oem_tire ? 'Street' : 'Touring'
    }
    if (points > 3.0001 && points <= 7.0001) {
      return 'Touring'
    }
    return 'Unlimited'
  }

  reset() {
    this.modTargets.forEach((element) => {
      element.checked = element.dataset.wasActive === 'true'
    })
    this.calculate()
  }

  initialize() {
    this.hasSummary = this.hasSumPointsTarget && this.hasSumCarClassTarget && this.hasSummaryTarget
    this.hasForm = this.hasRegPointsTarget && this.hasRegModsTarget && this.hasRegCarClassTarget
    if (this.hasSummary) this.summaryPopover = new Popover(this.summaryTarget)
    this.calculate()
  }

  disconnect() {
    if (this.hasSummary) this.summaryPopover.dispose()
  }
}
